import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DepositPayment } from './deposit-payment.model';

export const PAYMENT_CALCULATION_SCHEMA = Object.freeze({
  AMOUNT_PAID: 0,
  FEES_PAID: 0,
  TIP_PAID: 0,
  AMOUNT_PAID_EXCLUDING_FEES: 0,
  IS_FULLY_PAID: false,
  OUTSTANDING_BALANCE: 0,
  DEPOSIT: null, // DepositPayment
});

const RECORD = generateSchema(PAYMENT_CALCULATION_SCHEMA);
const KEYS: any = generateKeys(PAYMENT_CALCULATION_SCHEMA);

export class PaymentCalculation extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.DEPOSIT,
        value: props.get(KEYS.DEPOSIT)
          ? new DepositPayment(this.deposit)
          : null,
      },
    ]);

    return selfModel as PaymentCalculation;
  }

  get amountPaidExcludingFees(): number {
    return this.get(KEYS.AMOUNT_PAID_EXCLUDING_FEES);
  }

  get isFullyPaid(): boolean {
    return this.get(KEYS.IS_FULLY_PAID);
  }

  get outstandingBalance(): number {
    return this.get(KEYS.OUTSTANDING_BALANCE);
  }

  get deposit(): DepositPayment {
    return this.get(KEYS.DEPOSIT);
  }
}
